// extracted by mini-css-extract-plugin
export var modal = "_lj-0";